import { Z2HLayout } from "layouts";
import { Section, Container, Z2HMenu, Wistia } from "components";
import Link from "next/link";
import Image from "next/legacy/image";
import Head from "next/head";
import * as cx from "classnames/bind";
import s from "styles/Z2H.module.scss";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

export default function Contact({ policies }) {
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <title key="title">Fine strainer - Zero to hero - Cocktail Club</title>
        <meta
          key="ogTitle"
          property="og:title"
          content="Fine strainer - Zero to hero - Cocktail Club"
        />
        <meta
          key="ogUrl"
          property="og:url"
          content="https://cocktailclub.com/z2h/fine-strainer"
        />
        <link
          key="canonical"
          rel="canonical"
          href="https://cocktailclub.com/z2h/fine-strainer"
        />
      </Head>
      <Z2HLayout>
        <Section>
          <Container>
            <Z2HMenu />
            <div className={cx(s.Z2HContent)}>
              <h1 className="Heading__main">
                {t("Fine strainer - Zero to hero")}
              </h1>
              <p>
                Certain cocktails require the removal of small particles to
                ensure a visually appealing and smooth-textured drink. This
                where the fine strainer comes into its own.
                <br />
                <br />
                Here are five of our favorites that benefit from the use of a
                fine strainer – although you may also find it useful in many
                other serves, depending on the ingredients used and your
                personal preferences for a slick presentation:
                <br />
                <Link href="/cocktails/clover-club">• Clover Club</Link>
                <br />
                <Link href="/cocktails/gin-fizz">• Gin fizz</Link>
                <br />
                <Link href="/cocktails/martini">• Martini</Link>
                <br />
                <Link href="/cocktails/daiquiri">• Daiquiri</Link>
                <br />
                <Link href="/cocktails/old-fashioned">• Old fashioned</Link>
              </p>
              <br />
              <br />
              <h2 className="Heading__sub Bold">Introduction</h2>
              <div className={cx("videoDisplay", s.videoDisplay)}>
                <Wistia code="o9whbnn5t4" size="56.25% 0 0 0" />
              </div>
              <h2 className="Heading__sub Bold">Getting started</h2>
              <div className={cx("videoDisplay", s.videoDisplay)}>
                <Wistia code="cjq8yto1qc" size="56.25% 0 0 0" />
              </div>
            </div>
          </Container>
        </Section>
      </Z2HLayout>
    </>
  );
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale)),
  },
});
